import type Company from '../models/company.js';
import { formatDate, formatMoney } from './format.js';
import { isRegistrar } from './registrars.js';

const COMPANIES_HOUSE_COMPANY_URL = 'https://find-and-update.company-information.service.gov.uk/company';

type TurnoverFigure = Pick<Company['turnover'], 'amount' | 'currencyUnit' | 'currencyResolved'>;

export function formatTurnoverAmount(turnover?: TurnoverFigure | null): string {
  if (!turnover) return 'N/A';
  if (turnover.currencyResolved) return formatMoney(turnover.amount, turnover.currencyUnit, { wholeUnits: true });

  const plain = formatMoney(turnover.amount, undefined, { wholeUnits: true });
  return turnover.currencyUnit ? `${plain} (${turnover.currencyUnit})` : plain;
}

export function formatTurnoverDate(value?: string | null): string {
  if (!value) return 'N/A';
  return formatDate(value, 'longDate', value);
}

export function companiesHouseFilingUrl(
  company: Pick<Company, 'companiesRegistrar'> | undefined,
  transactionId?: string | null,
): string | null {
  const registrar = company?.companiesRegistrar?.find((r) => isRegistrar(r, 'COMPANIES_HOUSE'));
  if (!registrar?.id) return null;

  const filingHistory = `${COMPANIES_HOUSE_COMPANY_URL}/${registrar.id}/filing-history`;
  return transactionId ? `${filingHistory}/${transactionId}/document?format=pdf&download=0` : filingHistory;
}
